import { EmptyMark } from './icons.js';

/** Prototype `emptyBox(title, sub)`. */
export function EmptyState({ title, sub }: { title: string; sub: string }) {
  return (
    <div className="empty">
      <div className="emp">
        <EmptyMark />
        <b>{title}</b>
        <span>{sub}</span>
      </div>
    </div>
  );
}
